export const CERTIFICATE_STATUS = {
    "NOT_REQUESTED":"not_requested",
    "REQUESTED":"requested",
    "ISSUED":"issued",
    "REJECTED":"rejected"
}